import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { signOut } from '../../actions/app.action';


const PublicRoute = ({ getUser, component: Component, ...rest }) => {

  const token = localStorage.getItem('token');

  useEffect(() => {
    const handleGetUser = () => {
      getUser(false);
    }
    handleGetUser();
  }, [getUser]);

  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />
      }}
    />
  )
}

export default PublicRoute;